import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { AuthService } from '../auth/auth.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
  }

  // Un token válido en storage sobrevive a un F5, pero el rol del usuario (auth.user()) solo se
  // carga en memoria vía loadMe() — sin esto, un roleGuard hijo evaluaría roles() vacío en una
  // recarga directa a una ruta ADMIN y rebotaría a /403 a un usuario que sí tiene el rol.
  if (auth.user()) {
    return true;
  }

  return auth.loadMe().pipe(
    map(() => true),
    catchError(() => of(router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } }))),
  );
};
